import React from 'react';
import PropTypes from 'prop-types';

import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import CheckCircle from '@zg-rentals/multibrand-ui/lib/icons/CheckCircle';

import ListingActivationTerms from 'app/shared/components/ListingActivationTerms';

import './style.scss';

const PaidInclusionPostPublishModal = ({
    onEnableApplications,
    onGotItClick,
    expirationDate,
    isListingFree,
    includeUpsell,
    paths,
    price,
}) => (
    <React.Fragment>
        <SpacerRow>
            <CheckCircle colorType="success" size={100} />
        </SpacerRow>
        <SpacerRow>
            <Text type="h2">Your listing has been published!</Text>
        </SpacerRow>
        <SpacerRow>
            {isListingFree ? (
                <Text type="body">
                    Your listing will remain active for 4 weeks or until you deactivate it. You can republish it if you
                    need more time to find your next renter.
                </Text>
            ) : (
                <Text type="body">
                    {`Your listing will renew each week unless you deactivate it. Your card will be charged ${price}
                    each time. You’ll be notified 48 hours before each renewal.`}
                </Text>
            )}
        </SpacerRow>
        <SpacerRow data-test="date-row">
            <Text type="h3">
                {isListingFree ? 'Expires' : 'Renews'}
                :&nbsp;
                {expirationDate}
            </Text>
        </SpacerRow>
        {includeUpsell && (
            <div data-test="applications-upsell" className="PostPublishModal-upsell">
                <SpacerRow>
                    <Text type="h3">Save time with online applications!</Text>
                </SpacerRow>
                <SpacerRow>
                    <Text type="body">
                        Finding a great tenant is easier with applications and screening tools all in one place. Use our
                        online application form with background check and credit screening to find a renter
                        quickly!&nbsp;
                        <Link type="secondary" href={paths.marketingRoutes.screening} target="_blank">
                            Learn more
                        </Link>
                        .
                    </Text>
                </SpacerRow>
                <SpacerRow>
                    <Button full={true} type="primary" onClick={onEnableApplications}>
                        Yes, enable applications
                    </Button>
                </SpacerRow>
                <SpacerRow>
                    <ListingActivationTerms actionText="By enabling applications" />
                </SpacerRow>
            </div>
        )}
        {!includeUpsell && (
            <SpacerRow className="ModalActions">
                <Button type="primary" full={true} onClick={onGotItClick}>
                    Got it
                </Button>
            </SpacerRow>
        )}
    </React.Fragment>
);

PaidInclusionPostPublishModal.propTypes = {
    onEnableApplications: PropTypes.func.isRequired,
    onGotItClick: PropTypes.func.isRequired,
    isListingFree: PropTypes.bool.isRequired,
    includeUpsell: PropTypes.bool.isRequired,
    expirationDate: PropTypes.string.isRequired,
    paths: PropTypes.object.isRequired,
};

export default PaidInclusionPostPublishModal;
